import { gql } from "@apollo/client";
export const SearchWorkItemEntries = gql`
  mutation SearchWorkItems(
    $request: SearchWorkItemRequest!
  ) {
    SearchWorkItems(
      request: $request
    ) {
      data
      total
    }
  }
`;
